var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3321 21.1451H11.5858L9.52638 13.0573C9.42863 12.6852 9.22108 12.3563 8.91579 12.2013C8.15389 11.8118 7.31432 11.5017 6.39844 11.3454V11.034H10.8225C11.4331 11.034 11.8911 11.5017 11.9674 12.045L13.0359 17.879L15.7809 11.034H18.4509L14.3321 21.1451ZM19.9774 21.1451H17.3837L19.5195 11.034H22.1131L19.9774 21.1451ZM25.4687 13.8351C25.545 13.2905 26.003 12.9791 26.5372 12.9791C27.3768 12.9009 28.2914 13.0573 29.0546 13.4455L29.5125 11.2685C28.7493 10.9571 27.9097 10.8008 27.1478 10.8008C24.6305 10.8008 22.7987 12.2013 22.7987 14.1451C22.7987 15.6238 24.0962 16.4003 25.0121 16.868C26.003 17.3344 26.3846 17.6458 26.3083 18.1122C26.3083 18.8118 25.545 19.1232 24.7831 19.1232C23.8672 19.1232 22.9514 18.89 22.1131 18.5004L21.6552 20.6787C22.5711 21.0669 23.5619 21.2233 24.4778 21.2233C27.3005 21.3001 29.0546 19.9009 29.0546 17.8008C29.0546 15.1561 25.4687 15.0011 25.4687 13.8351ZM38.1318 21.1451L36.0724 11.034H33.8603C33.4024 11.034 32.9444 11.3454 32.7918 11.8118L28.9783 21.1451H31.6483L32.1812 19.6677H35.4618L35.7671 21.1451H38.1318ZM34.2419 13.7569L35.0038 17.5676H32.8681L34.2419 13.7569Z",
    fill: "#172B85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    stroke: "#F2F4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.f1a0f0ce2924ac3b833d4b488fcd6d01.svg";
export { ForwardRef as ReactComponent };